// extracted by mini-css-extract-plugin
export var btnWrapper = "ImageSection-module--btnWrapper--dc186";
export var image = "ImageSection-module--image--035c5";
export var text = "ImageSection-module--text--c6388";
export var title = "ImageSection-module--title--e8671";
export var wrapper = "ImageSection-module--wrapper--bdb86";